import { createContext } from 'react';
import { factionNames } from '../../hooks/useFactionData/useFactionData.constant';

export const FactionContext = createContext<{ faction: string, updateFaction: (f: string) => void }>({
  faction: factionNames[0],
  updateFaction: () => {/** */}
});